import React from "react";

// others
import { changeHistoryColumn, mappedStatusHistory } from "../utils";
import Grid from "../../../../atoms/Grid";
import { useSelector } from "react-redux";

interface IProps {
  parentState: (obj: object) => void;
  onModalClose:any,
  screen?:string,
  historyData?:Object
}

const index = (props: IProps) => {
  // redux states
  const { bookingDetails } = useSelector((state: any) => state.newBooking);

  return (
    <div className="bf-main view-booking edit-payment-schedule change-history">
      <Grid
        fullPage={true}
        className={'header-height-settings'}
        columns={changeHistoryColumn(props?.onModalClose,bookingDetails,props?.screen)}
        data={props?.screen === 'payment' ? props?.historyData : mappedStatusHistory(bookingDetails)}
      />
    </div>
  );
};

export default React.memo(index);
